export const isNdviValueType = (valueType?: string | null): boolean =>
  valueType === 'imageryOverlayNDVI_current' ||
  valueType === 'imageryOverlayNDVIChange_sinceLastImage' ||
  valueType === 'imageryOverlayNDVIChange_sinceLastMonth'
